const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRProgressDelivered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-progress-delivered",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.702,11.026c0.184,0.193 0.298,0.455 0.298,0.743c0,0.306 -0.128,0.583 -0.333,0.779l-0,0l-7.898,7.539c-0.193,0.184 -0.455,0.298 -0.743,0.298c-0.289,-0 -0.551,-0.114 -0.744,-0.299l0,0.001l-3.949,-3.769c-0.205,-0.197 -0.333,-0.473 -0.333,-0.779c0,-0.595 0.482,-1.077 1.077,-1.077c0.288,-0 0.551,0.113 0.744,0.298l-0.001,-0l3.206,3.059l7.154,-6.829c0.192,-0.184 0.455,-0.298 0.743,-0.298c0.306,0 0.583,0.128 0.779,0.333l0,0.001l0,-0Zm7.298,3.974c0,7.732 -6.268,14 -14,14c-7.732,-0 -14,-6.268 -14,-14c0,-7.732 6.268,-14 14,-14c7.728,0.009 13.991,6.272 14,13.999l0,0.001Zm-2.154,-0c0,-6.542 -5.304,-11.846 -11.846,-11.846c-6.542,-0 -11.846,5.304 -11.846,11.846c-0,6.542 5.304,11.846 11.846,11.846c6.539,-0.007 11.839,-5.307 11.846,-11.845l0,-0.001Z",
    style: {
      fill: "#01b800",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRProgressDelivered);
export default __webpack_public_path__ + "static/media/iconR-progress-delivered.f0ae2b6e1ac2783526d117e2b5f101d6.svg";
export { ForwardRef as ReactComponent };